import axios from "axios";

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 5000,
  headers: {
    "Ocp-Apim-Subscription-Key": process.env.VUE_APP_API_AUTH,
  },
});

export default httpClient;
